<template>
  <div class="portal-home-font-2x min-h-screen bg-surface text-on-surface flex flex-col">
    <main class="flex-1 w-full max-w-[1440px] mx-auto px-8 pt-40 pb-24 flex items-center justify-center">
      <section class="w-full max-w-3xl bg-surface-container-lowest rounded-[32px] shadow-sm border border-surface-dim/60 px-8 py-16 md:px-14 md:py-20 text-center">
        <div class="space-y-6">
          <span class="material-symbols-outlined text-primary text-6xl" style="font-variation-settings: 'FILL' 0, 'wght' 300, 'GRAD' 0, 'opsz' 48;">pending</span>
          <h1 class="text-4xl font-headline font-bold text-primary">内容制作中，敬请期待......</h1>
          <p class="text-on-surface-variant text-lg leading-relaxed max-w-2xl mx-auto">
            我们正在为您准备更丰富的内容与功能。请稍后再回来查看。
          </p>
          <div class="pt-8 flex justify-center">
            <button @click="goBack" class="bg-primary text-on-primary px-8 py-3 rounded-lg font-bold hover:opacity-90 transition-all flex items-center justify-center gap-2 shadow-sm">
              <span class="material-symbols-outlined">arrow_back</span>
              返回上一页
            </button>
          </div>
        </div>
      </section>
    </main>

    <portal-footer />
  </div>
</template>

<script>
import PortalFooter from '@/components/PortalFooter.vue'

export default {
  name: 'ComingSoon',
  components: {
    PortalFooter
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ComingSoon.vue